import { render } from "./PermitModal.vue?vue&type=template&id=19d7a71c"
import script from "./PermitModal.vue?vue&type=script&lang=ts"
export * from "./PermitModal.vue?vue&type=script&lang=ts"
script.render = render

export default script